/**
 * Shared localStorage helpers for case-experience modals that must survive refresh.
 * Keys are namespaced per document so concurrent cases do not collide.
 */

export function caseViewerDocumentId() {
  const el = document.getElementById('document-container');
  if (!el) return null;
  const documentId = Number(el.getAttribute('data-case-experience--case-viewer-document-id-value'));
  if (!Number.isFinite(documentId) || documentId <= 0) return null;
  return documentId;
}

/**
 * @param {string} keyPrefix e.g. 'case-experience:lowTimeModalPending:'
 * @param {{ legacyKeys?: string[] }} [options]
 */
export function createModalPendingStorage(keyPrefix, { legacyKeys = [] } = {}) {
  function storageKey(documentId = caseViewerDocumentId()) {
    if (documentId == null) return null;
    return `${keyPrefix}${documentId}`;
  }

  function isPending(documentId = caseViewerDocumentId()) {
    if (documentId == null || typeof localStorage === 'undefined') return false;
    const key = storageKey(documentId);
    return key != null && localStorage.getItem(key) === 'true';
  }

  /**
   * Client-only UI flag so a modal survives refresh.
   * Not shared across devices/sessions — set true before open, remove on complete/reset.
   */
  function persist(pending, documentId = caseViewerDocumentId()) {
    if (documentId == null || typeof localStorage === 'undefined') return false;

    const key = storageKey(documentId);
    if (!key) return false;

    if (pending === true) {
      localStorage.setItem(key, 'true');
    } else {
      localStorage.removeItem(key);
      legacyKeys.forEach((legacyKey) => localStorage.removeItem(legacyKey));
    }
    return true;
  }

  return { storageKey, isPending, persist };
}
